import { useEffect, useRef, useCallback } from "react"; 
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logout } from "../store/slices/authSlice";

const IDLE_TIMEOUT = 30 * 60 * 1000; // 30 minutes

const useAutoLogout = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const timerRef = useRef(null);
    const isAuthenticated = useSelector((state) => state.auth.authenticated);

    const handleLogout = useCallback(() => {
        dispatch(logout());
        navigate("/", { replace: true });
    }, [dispatch, navigate]);

    const resetTimer = useCallback(() => {
        if (timerRef.current) {
            clearTimeout(timerRef.current);
        }
        timerRef.current = setTimeout(() => {
            handleLogout();
        }, IDLE_TIMEOUT);
    }, [handleLogout]);

    useEffect(() => {
        if (!isAuthenticated) {
            if (timerRef.current) clearTimeout(timerRef.current);
            return;
        }

        const activityEvents = [
            "mousemove",
            "mousedown",
            "keydown",
            "scroll",
            "touchstart",
            "click",
        ];

        resetTimer();

        activityEvents.forEach((event) => {
            window.addEventListener(event, resetTimer);
        });

        return () => {
            if (timerRef.current) clearTimeout(timerRef.current);
            activityEvents.forEach((event) => {
                window.removeEventListener(event, resetTimer);
            });
        };
    }, [isAuthenticated, resetTimer]);
};

export default useAutoLogout;